import { no as reactno } from '@ews/react-translations';

const no = {
...reactno
}
export default no
